import { proxyBE } from './common';

export const lessonSectionService = {
  getSectionsByCourseType(courseType, aa) {
    return proxyBE.get(`/admin/lesson/section/${courseType}/${aa}`);
  },

  getLessonsBySection(section, courseCode, aa) {
    return proxyBE.get(`/admin/lesson/section/lessons/${section}/${courseCode}/${aa}`);
  },

    MySchedule(courseId, rCode) {
        let url = `/lesson/section/my-schedule/${courseId}/${rCode}`;
        return proxyBE.get(url);
    },

    listAnalyticsStudents(courseType, idExamSession, academicYear, companySectionGroup = '') {
        return proxyBE.get(`admin/lesson/section/analytics-list/${courseType}/${idExamSession}/${academicYear}/${companySectionGroup}`);
    },

    listAnalyticsStudentsTFAIndire(academicYear, courseCode, prediction = '') {
        return proxyBE.get(`admin/lesson/section/analytics-list-tfa-indire/${academicYear}/${courseCode}/${prediction}`);
    },

    listAnalyticsStudentsTFAClassico(academicYear, courseCode) {        
        return proxyBE.get(`admin/lesson/section/analytics-list-tfa-classico/${academicYear}/${courseCode}`);
    },

    analizeAnalyticsStudentsTFAClassico(academicYear, courseCode) {        
        return proxyBE.post(
            `admin/lesson/section/analytics-create-tfa-classico/${academicYear}/${courseCode}`
        );
    },

    getAnalyticStudentTFAIndire(registrationCode) {
        return proxyBE.get(`admin/lesson/section/analytics-student-tfa-indire/${registrationCode}`);
    },

    analizeAnalyticsStudentsTFAIndire(academicYear, courseCode) {
        return proxyBE.post(
            `admin/lesson/section/analytics-create-tfa-indire/${academicYear}/${courseCode}`
        );
    },

  listAnalyticsStudent(registrationCode) {
    return proxyBE.get(`admin/lesson/section/analytics-student/${registrationCode}`);
  },

  getAnalyticsStudent(registrationCode) {
    return proxyBE.get(`admin/lesson/analytics-list/${registrationCode}`);
  },

  getAnalyticsDetail(registrationCode, lessonType, lessonId, mode) {
    return proxyBE.get(`admin/lesson/analytics-detail/${registrationCode}/${lessonType}/${lessonId}/${mode}`);
  },

  getAnalyticsStudentSection(registrationCode) {
    return proxyBE.get(`admin/lesson/section/analytics-detail/${registrationCode}`);
  },

  createAnalyticsStudents(idExamSession, academicYear) {
    return proxyBE.post(`admin/lesson/section/analytics-create/${idExamSession}/${academicYear}`);
  },

  createAnalyticsStudent(registrationCode, idExamSession, academicYear) {
    return proxyBE.post(`admin/lesson/section/analytics-create-student/${registrationCode}/${idExamSession}/${academicYear}`);
  },

  insertRecoveryResume(payload) {
    return proxyBE.post("admin/lesson/resume", payload);
  },
};
